/**
 * This file is auto-generated from DateInput.loc.yaml
 * Do not edit this file directly. Edit the source file instead.
 */

import type { Translation } from '@nzyme/i18n-core';

export const dayLabel: Translation = lang => {
    switch (lang) {
        case 'en':
            return 'Day';
        case 'pl':
            return 'Dzień';
    }
};

export const monthLabel: Translation = lang => {
    switch (lang) {
        case 'en':
            return 'Month';
        case 'pl':
            return 'Miesiąc';
    }
};

export const yearLabel: Translation = lang => {
    switch (lang) {
        case 'en':
            return 'Year';
        case 'pl':
            return 'Rok';
    }
};

export const openCalendar: Translation = lang => {
    switch (lang) {
        case 'en':
            return 'Open calendar';
        case 'pl':
            return 'Otwórz kalendarz';
    }
};
